/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Account-status transition request body. The acting staff user's id is injected
 * server-side from the authenticated session; clients send only the reason.
 * @export
 * @interface PamAccountStatusBody
 */
export interface PamAccountStatusBody {
    /**
     * 
     * @type {string}
     * @memberof PamAccountStatusBody
     */
    reason: string;
}

/**
 * Check if a given object implements the PamAccountStatusBody interface.
 */
export function instanceOfPamAccountStatusBody(value: object): value is PamAccountStatusBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function PamAccountStatusBodyFromJSON(json: any): PamAccountStatusBody {
    return PamAccountStatusBodyFromJSONTyped(json, false);
}

export function PamAccountStatusBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamAccountStatusBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function PamAccountStatusBodyToJSON(value?: PamAccountStatusBody | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

